"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionInteractionBaseSchema = exports.sessionInteractionReplyTypeSchema = exports.sessionKindSchema = void 0;
const zod_1 = require("zod");
exports.sessionKindSchema = zod_1.z.enum([
    "conversation",
    "be-teacher",
    "stateless",
    "activity",
    "bot",
    "placement-test",
    "onboarding:product-discovery",
    "onboarding:user-data-collection",
    "onboarding:social-proof",
    "onboarding:post-purchase",
    "sales-rep",
]);
exports.sessionInteractionReplyTypeSchema = zod_1.z.enum(["audio", "text"]);
exports.sessionInteractionBaseSchema = zod_1.z.object({
    sessionKind: exports.sessionKindSchema,
    sessionId: zod_1.z.string(),
    aggregationId: zod_1.z.string().optional(),
    _id: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    from: zod_1.z.enum(["user", "bot", "system"]),
    jwt: zod_1.z.string().optional(),
});
//# sourceMappingURL=base.js.map